import React from 'react'
import CheckoutComponent from '../components/checkout/Checkout.Component';

const CheckOutPageComponent = () => {
  return (
    <CheckoutComponent />
  )
}

export default CheckOutPageComponent;